import { Dropdown } from 'containers';
import { Container, Store, wrap, Wrapper } from 'AppReact';
import { InputError } from 'molecules';
import device from 'utils/device';
import styled from 'styled-components';
import { Description } from '../../../common/atoms';
import { FieldWrapper } from '../../../common/wrappers';
import { switchLabel } from '../../../utilities';
import { LabeledDatepicker } from 'containers';
import { SecondaryTextXs } from 'atoms';
import { getAvailableUnits } from '../../../utils';

const WrappedDropdown = wrap(Dropdown, FieldWrapper);
const WrappedDatePicker = wrap(LabeledDatepicker, FieldWrapper);
const WrappedInputError = wrap(InputError, FieldWrapper);

const template = styled.div`
    width: 336px;
    padding: 0 24px;
    margin: 0 auto;

    @media ${device.tablet} {
        width: 594px;
    }
`;
export const definition = {
  name: 'MoveInInfo',
  props: { property: Store, moveInInformation: Store, selectedTabId: Store, language: Store, availableUnits: Store },
  elements: [
    {
      wrapper: Wrapper(template),
      name: 'Wrapper',
      elements: [
        {
          componentSelect: switchLabel,
          name: 'SectionTitle',
          displayValue: ({ language }) => `${language?.mii || 'Move In Information'}`,
          bindings: ({ selectedTabId }) => ({ Id: selectedTabId, label: 'Name:', value: '' })
        },
        {
          component: WrappedDatePicker,
          name: 'ExpectedMoveIn',
          bindings: ({ moveInInformation, language }) => ({ moveInInformation, selectedDate: moveInInformation?.moveInDate, label: { values: [`${language?.emi || 'Expected Move In:'}`], keys: ['text'], component: SecondaryTextXs }, })
        },
        {
          component: WrappedInputError,
          name: 'ExpectedMoveInError',
          bindings: ({ moveInInformation }) => ({ error: moveInInformation.moveInDateError }),
          renderIf: ({ moveInInformation, selectedTabId }) => !!moveInInformation.moveInDateError && selectedTabId !== 'review'
        },
        {
          component: WrappedDropdown,
          name: 'FloorPlanDropdown',
          bindings: ({ property, moveInInformation, availableUnits }) => {
            const options = property?.floor_plans?.map((item) => {
              const { name: display } = item;
              const withModifiedKeys = { ...item, display };
              delete withModifiedKeys.name;

              return withModifiedKeys;
            });

            return ({ moveInInformation, label: 'Floor Plan: ', selectedOptionId: moveInInformation?.selectedFloorPlan, options, property, availableUnits });
          }
        },
        {
          component: WrappedInputError,
          name: 'FloorPlanError',
          bindings: ({ moveInInformation }) => ({ error: moveInInformation?.selectedFloorPlanError || ''}),
          renderIf: ({ moveInInformation, selectedTabId }) => !!moveInInformation?.selectedFloorPlanError && selectedTabId !== 'review'
        },
        {
          component: WrappedDropdown,
          name: 'UnitDropdown',
          renderIf: ({ availableUnits, moveInInformation }) => moveInInformation.selectedFloorPlan && window.CLIENT_SCHEMA === 'dasmen' && availableUnits.length > 0,
          bindings: ({ property, availableUnits, moveInInformation }) => {
            const options = getAvailableUnits({ property, moveInInformation, availableUnits })
            return ({ moveInInformation, label: 'Unit: ', selectedOptionId: moveInInformation?.selectedUnitNumber, options });
          }
        },
        {
          component: WrappedInputError,
          name: 'UnitError',
          bindings: ({ moveInInformation }) => ({ error: moveInInformation?.selectedUnitNumberError || ''}),
          renderIf: ({ moveInInformation, selectedTabId }) => !!moveInInformation?.selectedUnitNumberError && selectedTabId !== 'review'
        },
        {
          component: wrap(Description, Wrapper(styled.div`margin-top:40px; display: flex; flex-direction:column; justify-content: center; align-items: center;`)),
          name: 'Description',
          displayState: () => ({ textAlignment: 'center' }),
          displayValue: () => `Pricing and availability is subject to change at any time. Selecting a particular floorplan does not guarantee that floorplans availability. If a floorplan is not available for your desired move in date, an alternative floorplan may be proposed, or you may be placed on a waitlist. The price listed here is the base rent and does not include any other fees.`,
        }
      ]
    }
  ]
};

const MoveInInfo = Container(definition);

export default MoveInInfo;
